import { Article } from '@/lib/articles';
import { Badge } from '../services/Badge';
import { Link } from 'react-router-dom';

interface BlogCardProps {
	article: Article;
}

const BlogCard = ({ article }: BlogCardProps) => {
	return (
		<Link to={`/blog/${article.id}`} className='block h-full'>
			<div className='w-full h-full bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 blog-card-hover'>
				<div className='flex flex-col h-full'>
					<div className='relative h-52 overflow-hidden'>
						<img
							src={article.imageUrl}
							alt={article.title}
							className='w-full h-full object-cover object-center blog-card-image'
							loading='lazy'
						/>

						<div className='absolute top-3 left-3'>
							<Badge
								borderClassName='border-[#fbb040]'
								textClassName='text-white'
								text={article.category}
							/>
						</div>
					</div>

					<div className='flex-grow p-4 sm:p-5 flex flex-col'>
						<h2 className='text-xl font-bold text-gray-900 mb-2 line-clamp-2 text-balance'>
							{article.title}
						</h2>

						<p className='text-gray-600 text-sm line-clamp-2 mb-4 flex-grow text-balance'>
							{article.excerpt}
						</p>

						<div className='mt-auto pt-3 border-t border-gray-100 flex items-center justify-between text-sm text-gray-500'>
							{/* <span className='font-medium text-gray-700'>
								{article.author}
							</span> */}
							<div className='flex items-center space-x-1'>
								<span>{article.published}</span>
								<span>•</span>
								<span>{article.readTime} minutes</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Link>
	);
};

export default BlogCard;
